// extracted by mini-css-extract-plugin
export default {"cover_card":"Carousel_cover_card__tOner","cover_caption":"Carousel_cover_caption__oqZ5z","cover_thumb":"Carousel_cover_thumb__v7pvD","mobile_drag":"Carousel_mobile_drag__SQ9AI"};